import * as React from 'react';

import { createNativeStackNavigator } from "@react-navigation/native-stack";

import TelaLogin from '../telas/TelaLogin'

import TelaPrincipal from '../telas/TelaPrincipal'

import TelaDetalheUsuario from '../telas/TelaDetalheUsuario'

import TelaNovoUsuario from '../telas/TelaNovoUsuario'

import TelaMeusItens from '../telas/TelaMeusItens'

import TelaNovoItem from '../telas/TelaNovoItem'

import TelaMeusPedidos from '../telas/TelaMeusPedidos'

import TelaNovoPedido from '../telas/TelaNovoPedido'

import TelaChat from '../telas/TelaChat'

import TelaMinhasPropostas from '../telas/TelaMinhasPropostas'

import TelaNovaProposta from '../telas/TelaNovaProposta'

import TelaDetalheProposta from '../telas/TelaDetalheProposta'

import TelaPropostasMeuPedido from '../telas/TelaPropostasMeuPedido'

import TelaFinanceiro from '../telas/TelaFinanceiro'

import TelaDetalheItem from '../telas/TelaDetalheItem'

import TelaDetalhePedido from '../telas/TelaDetalhePedido'

import TelaMeusEnderecos from '../telas/TelaMeusEnderecos'

import TelaAnuncio from '../telas/TelaAnuncio'

import TelaBuscarItens from '../telas/TelaBuscarItens'

import TelaBuscarPedidos from '../telas/TelaBuscarPedidos'

import TelaLoja from '../telas/TelaLoja'

import TelaCategorias from '../telas/TelaCategorias'

import TelaSubcategorias from '../telas/TelaSubcategorias'

import TelaNovaDenuncia from '../telas/TelaNovaDenuncia'

import TelaDenuncias from '../telas/TelaDenuncias'

import {TELA_LOGIN, TELA_PRINCIPAL, TELA_DETALHE_USUARIO, 
    TELA_NOVO_ITEM, TELA_MEUS_ITENS, TELA_NOVO_USUARIO,
        TELA_ANUNCIO, TELA_MEUS_PEDIDOS, TELA_NOVO_PEDIDO, 
        TELA_MINHAS_PROPOSTAS, TELA_NOVA_PROPOSTA, TELA_DETALHE_PROPOSTA,
        TELA_CATEGORIA, TELA_SUBCATEGORIA, TELA_BUSCAR_PEDIDOS, TELA_BUSCAR_ITENS,
        TELA_LOJA, TELA_MEUS_ENDERECOS,
        TELA_FINANCEIRA,TELA_PROPOSTAS_MEU_PEDIDO,
        TELA_CHAT,
        TELA_DETALHE_ITEM,
        TELA_DETALHE_PEDIDO, TELA_LOJA_EXTERNO, TELA_NOVA_DENUNCIA,
        TELA_DENUNCIAS} from '../util/constantes'



const Stack  =createNativeStackNavigator();





export default function Routes(){
    
    return (

        <Stack.Navigator initialRouteName={TELA_LOGIN}>
            <Stack.Screen   
                name={TELA_LOGIN}
                component={TelaLogin}
                options={{headerShown:false}}/>

			<Stack.Screen   
                name={TELA_PRINCIPAL}
                component={TelaPrincipal}
                options={{headerShown:false}}/>

			<Stack.Screen   
                name={TELA_NOVO_USUARIO}
                component={TelaNovoUsuario}
                options={{headerShown:false}}/>
			
            <Stack.Screen   
                name={TELA_DETALHE_USUARIO}
                component={TelaDetalheUsuario}
                options={{headerShown:false}}/>

			<Stack.Screen   
                name={TELA_MEUS_ITENS}
                component={TelaMeusItens}
                options={{headerShown:false}}/>
			
			<Stack.Screen   
                name={TELA_NOVO_ITEM}
                component={TelaNovoItem}
                options={{headerShown:false}}/>

            <Stack.Screen   
                name={TELA_ANUNCIO}
                component={TelaAnuncio}
                options={{headerShown:false}}/>

			<Stack.Screen   
                name={TELA_MEUS_PEDIDOS}
                component={TelaMeusPedidos}
                options={{headerShown:false}}/>
			
			<Stack.Screen   
                name={TELA_NOVO_PEDIDO}
                component={TelaNovoPedido}
                options={{headerShown:false}}/>

			<Stack.Screen   
                name={TELA_CHAT}
                component={TelaChat}
                options={{headerShown:false}}/>
				
			<Stack.Screen   
                name={TELA_MINHAS_PROPOSTAS}
                component={TelaMinhasPropostas}
                options={{headerShown:false}}/>

			<Stack.Screen   
                name={TELA_NOVA_PROPOSTA}
                component={TelaNovaProposta}
                options={{headerShown:false}}/>
				
			<Stack.Screen   
                name={TELA_DETALHE_PROPOSTA}
                component={TelaDetalheProposta}
                options={{headerShown:false}}/>

			<Stack.Screen   
                name={TELA_PROPOSTAS_MEU_PEDIDO}
                component={TelaPropostasMeuPedido}
                options={{headerShown:false}}/>

			<Stack.Screen   
                name={TELA_FINANCEIRA}
                component={TelaFinanceiro}
                options={{headerShown:false}}/>

			<Stack.Screen   
                name={TELA_DETALHE_ITEM}
                component={TelaDetalheItem}
                options={{headerShown:false}}/>
					
			<Stack.Screen   
                name={TELA_DETALHE_PEDIDO}
                component={TelaDetalhePedido}
                options={{headerShown:false}}/>
			
			<Stack.Screen   
                name={TELA_MEUS_ENDERECOS}
                component={TelaMeusEnderecos}
                options={{headerShown:false}}/>

			<Stack.Screen   
                name={TELA_BUSCAR_ITENS}
                component={TelaBuscarItens}
                options={{headerShown:false}}/>
	
			<Stack.Screen   
                name={TELA_BUSCAR_PEDIDOS}
                component={TelaBuscarPedidos}
                options={{headerShown:false}}/>
	
			<Stack.Screen   
                name={TELA_LOJA}
                component={TelaLoja}
                options={{headerShown:false}}/>

            <Stack.Screen   
                name={TELA_LOJA_EXTERNO}
                component={TelaLoja}
                options={{headerShown:false}}/>
	
			<Stack.Screen   
                name={TELA_CATEGORIA}
                component={TelaCategorias}
                options={{headerShown:false}}/>

			<Stack.Screen   
                name={TELA_SUBCATEGORIA}
                component={TelaSubcategorias}
                options={{headerShown:false}}/>

            <Stack.Screen   
                name={TELA_NOVA_DENUNCIA}
                component={TelaNovaDenuncia}
                options={{headerShown:false}}/>

            <Stack.Screen   
                name={TELA_DENUNCIAS}
                component={TelaDenuncias}
                options={{headerShown:false}}/>

        </Stack.Navigator>
    )
}